module.exports = __webpack_public_path__ + "assets/img/change1.b7ca6ffa.png";